import { useAppLogo } from "helpers/useAppSetting";
import { CHECK_DISPLAY_CLS } from "../pifStyles";
import { formatDate } from "helpers/utils";
import { Link } from "react-router-dom";
import React from 'react';
import PropTypes from 'prop-types';

const BDS1 = ({pif, area}) => {
  const logo = useAppLogo();
  const {project, building, adaptation} = pif;
  const bds1 = area?.bds1 || {};
  const openWallData = bds1?.open_walls || [];

  const projectUrl = `/crm/projects/${project?.id}`;

  return (
    <table className="tw-text-sm tw-mt-5">
      <tr>
        <td colSpan="2" className="tw-text-left tw-font-bold">
          Building Data Sheet 1
        </td>
        <td colSpan="6" className="tw-text-center">
          <div className="tw-text-2xl tw-font-bold tw-mb-2">PROJECT INFORMATION FORM</div>
        </td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          This building only: 1 of 3
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="2" className="tw-text-center">
          <img
            src={logo}
            alt="Logo Pebsteel"
            width="160"
            height="60"
            className="tw-object-contain tw-rounded-sm"
            style={{maxWidth: '100%'}}
          />
        </td>
        <td className="tw-font-bold">Quote No:</td>
        <td className="tw-text-primary-600">
          <Link to={projectUrl}>{project?.q_number}</Link>
        </td>
        <td className="tw-font-bold">Rev No:</td>
        <td className="tw-text-primary-600">{adaptation.rev}</td>
        <td className="tw-font-bold">Date:</td>
        <td className="tw-text-primary-600">{formatDate(adaptation.entry_date)}</td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          <div className="tw-flex tw-justify-around">
            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                name="for_order_entry"
                checked={!!(adaptation?.type === "change_order")}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For Order Entry</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                name="for_quotation"
                checked={!!(adaptation?.type === "revision")}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For Quotation</span>
            </label>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-font-bold">P/Job No:</td>
        <td className="tw-text-primary-600">
          <Link to={projectUrl}>{building?.j_number}</Link>
        </td>
        <td className="tw-font-bold">CO#:</td>
        <td className="tw-text-primary-600">{adaptation.co}</td>
        <td className="tw-font-bold">Date:</td>
        <td className="tw-text-primary-600">{formatDate(adaptation.entry_date)}</td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          <div className="tw-flex tw-justify-around">
            <div>
              Bldg No: <span className="tw-text-primary-600">{building?.name}</span>
            </div>
            <div>
              Area No: <span className="tw-text-primary-600">{area?.id}</span>
            </div>
          </div>
          <h6 className="tw-text-center tw-my-2">This area only : Page 1 of 3</h6>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">1</td>
        <td className="tw-font-bold tw-text-center">GENERAL INFORMATION</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-1 tw-mb-2 tw-mt-4">
            <div className="tw-col-span-6">
              <div className="tw-flex tw-gap-2 tw-mb-2">
                <div className="tw-w-1/4">Customer name:</div>
                <div className="tw-font-semibold tw-text-primary-600">{project.customer?.name}</div>
              </div>
              <div className="tw-flex tw-gap-2 tw-mb-2">
                <div className="tw-w-1/4">Project name:</div>
                <div className="tw-font-semibold tw-text-primary-600">{project.name}</div>
              </div>
              <div className="tw-flex tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-w-1/4">Building usage:</div>
                <div className="tw-font-semibold">
                  <span className="tw-text-primary-600">{bds1.building_usage}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-6">
              <div className="tw-flex tw-gap-1 tw-mb-2">
                <div>Location:</div>
                <div className="tw-flex-1 tw-font-semibold tw-text-primary-600">{building.pj_location}</div>
              </div>
              <div className="tw-flex tw-gap-1 tw-mb-2 tw-items-center">
                <div>Qty of Identical Bldgs:</div>
                <div className="tw-flex-1 tw-font-semibold">
                  <span className="tw-text-primary-600">{bds1.qty_of_identical_bldgs}</span>
                </div>
              </div>
              <div className="tw-flex tw-gap-1 tw-mb-2 tw-items-center">
                <div>Estimated No. of trailers/ containers for all identical bldgs:</div>
                <div className="tw-flex-1 tw-font-semibold">
                  <span className="tw-text-primary-600">{bds1.estimated_no_trailed}</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">2</td>
        <td className="tw-font-bold tw-text-center">LOADS <br/> (kN/m2)</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-5">
              <div className="tw-grid tw-grid-cols-12 tw-gap-0 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Live (On Purlins):</div>
                <div className="tw-col-span-7">
                  <div className="tw-flex">
                    <span className="tw-text-primary-600">{bds1.loads_live_on_purlins} (KN/m2)</span>
                  </div>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-0 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">On Frames:</div>
                <div className="tw-col-span-7">
                  <div className="tw-flex">
                    <span className="tw-text-primary-600">{bds1.loads_on_frame} (KN/m2)</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Collateral on Frame:</div>
                <div className="tw-col-span-7">
                  <div className="tw-flex">
                    <span className="tw-text-primary-600">{bds1.loads_collateral_on_frame} (KN/m2)</span>
                  </div>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Collateral on Roof:</div>
                <div className="tw-col-span-7">
                  <div className="tw-flex">
                    <span className="tw-text-primary-600">{bds1.loads_collateral_on_roof} (KN/m2)</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw-col-span-2">
              <div className="tw-mt-3">
                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds1.loads_seismic)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Seismic</span>
                </label>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
            <div className="tw-col-span-5">
              <div className="tw-grid tw-grid-cols-12 tw-gap-0 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Wind Speed (KMH):</div>
                <div className="tw-col-span-7">
                  <span className="tw-text-primary-600">{bds1.loads_wind_speed} (KMH)</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-0 tw-mb-2 tw-items-center">
                <div className="tw-col-span-5">Recurrence time:</div>
                <div className="tw-col-span-7">
                  <span className="tw-text-primary-600">{bds1.loads_recurrence_time}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-7">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-3">Explosure:</div>
                <div className="tw-col-span-9">
                  <span className="tw-text-primary-600">{bds1.loads_explosure}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-3">Rainfall:</div>
                <div className="tw-col-span-9">
                  <div className="tw-flex tw-items-center">
                    <span className="tw-text-primary-600">{bds1.loads_rainfall} mm/hr</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-2 tw-items-center">
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-mb-2 tw-items-center">
                <div>Description of collateral load:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds1.loads_description}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-mb-2 tw-items-center">
                <div>Occupancy category:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds1.loads_occupancy_category}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2">
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-2">
                <div className="tw-font-semibold">Building Code:</div>
                <div className="tw-flex-1">
                  <div className="tw-flex tw-justify-between">
                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds1.loads_building_code_mbma_2012)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>MBMA 2012</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds1.loads_building_code_ibc_2018)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>IBC 2018</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <span dangerouslySetInnerHTML={{ __html: bds1.loads_building_code_others }}></span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-7">
              <div className="tw-flex tw-gap-2">
                <div className="tw-font-semibold">Design Standard:</div>
                <div className="tw-flex-1">
                  <div className="tw-flex tw-justify-around">
                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds1.loads_design_standard_aisc_asd89)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>AISC-ASD89</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds1.loads_design_standard_aisc_360_16)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>AISC360-16</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds1.loads_design_standard_aisi_2001)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>AISI 2001</span>
                    </label>

                  </div>
                </div>
              </div>
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <span dangerouslySetInnerHTML={{ __html: bds1.loads_design_standard_others }}></span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">3</td>
        <td className="tw-font-bold tw-text-center">GRADE</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
            <div className="tw-col-span-3">Primary member:</div>
            <div className="tw-col-span-9">
              <span className="tw-text-primary-600">{bds1.grade_primary_member}</span>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
            <div className="tw-col-span-3">Secondary member:</div>
            <div className="tw-col-span-9">
              <span className="tw-text-primary-600">{bds1.grade_secondary_member}</span>
            </div>
          </div>

          <div className="tw-flex tw-gap-2 tw-mt-3">
            <div className="tw-flex-1">
              <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: bds1.grade_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">4</td>
        <td className="tw-font-bold tw-text-center">BUILDING PARAMETERS</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-4">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Frame Type:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.building_parameters_frame_type}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-3">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-3">Slope:</div>
                <div className="tw-col-span-9">
                  <span className="tw-text-primary-600">{bds1.building_parameters_slope}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-3">Height (M):</div>
                <div className="tw-col-span-9">
                  <div className="tw-grid tw-grid-cols-12 tw-gap-1">
                    <div className="tw-col-span-6">
                      <span className="tw-text-primary-600">{bds1.building_parameters_height_other}</span>
                    </div>
                    <div className="tw-col-span-6">
                      <span className="tw-text-primary-600">{bds1.building_parameters_height}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Bldg Width (M):</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.building_parameters_bldgs_width}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Width modules:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.building_parameters_width_module}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-0 tw-mb-3 tw-items-center">
            <div className="tw-col-span-2">Length (M):</div>
            <div className="tw-col-span-10">
              <span className="tw-text-primary-600">{bds1.building_parameters_length}</span>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Bay Spacing (M):</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.building_parameters_bay_spacing}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Columns support:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.building_parameters_column_support}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mt-2">
            <div className="tw-flex-1">
              <span dangerouslySetInnerHTML={{ __html: bds1.building_parameters_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">5</td>
        <td className="tw-font-bold tw-text-center">ENDWALL CONDITION</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Left End Wall Frame:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.left_end_wall_frame}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Right End Wall Frame:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.right_end_wall_frame}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Left End Girt type:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.lef_end_girt_type}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Near Side Girt type:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.near_site_girt_type}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Wind Col. Spacing (M):</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.wind_col_spacing_left}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Wind Col. Spacing (M):</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.wind_col_spacing_right}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Right End Girt type:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.right_end_girt_type}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-items-center">
                <div className="tw-col-span-4">Far Side Girt type:</div>
                <div className="tw-col-span-8">
                  <span className="tw-text-primary-600">{bds1.far_side_girt_type}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mt-2">
            <div className="tw-flex-1">
              <span dangerouslySetInnerHTML={{ __html: bds1.endwall_condition_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">6</td>
        <td className="tw-font-bold tw-text-center">OPEN WALLS <br/> Lengths are <br/> measured from <br/> corner of NSW & LEW </td>
        <td colSpan="8">
        <div className="tw-text-sm tw-mt-2">
          <table>
            <thead className="tw-bg-slate-200 tw-text-slate-900">
              <tr className="tw-text-center" style={{height: "10px"}}>
                <th className="tw-border" rowSpan={2}>Location</th>
                <th className="tw-border" colSpan={3}>Length (mm)</th>
                <th className="tw-border" rowSpan={2}>Height (m)</th>
                <th className="tw-border" rowSpan={2}>Open for</th>
                <th className="tw-border" rowSpan={2}>Bracing Type</th>
              </tr>
              <tr className="tw-text-center">
                <th className="tw-border">Length</th>
                <th className="tw-border">From</th>
                <th className="tw-border">To</th>
              </tr>
            </thead>
            <tbody>
              {openWallData && openWallData.map((item, index) => (
                <tr key={index}>
                  <td className="tw-border">{item.location}</td>
                  <td className="tw-border">{item.length}</td>
                  <td className="tw-border">{item.length_from}</td>
                  <td className="tw-border">{item.length_to}</td>
                  <td className="tw-border tw-text-right">{item.height}</td>
                  <td className="tw-border">{item.open_for}</td>
                  <td className="tw-border">{item.bracing_type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tw-flex tw-gap-2 tw-mt-3 tw-mb-2">
          <div className="tw-flex-1">
            <span dangerouslySetInnerHTML={{ __html: bds1.open_walls_note }}></span>
          </div>
        </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">7</td>
        <td className="tw-font-bold tw-text-center">ROOF</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-2">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.roof_by_pebsteel)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>by PEB Steel</span>
              </label>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Panel is:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds1.roof_panel_is}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Profile:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds1.roof_profile}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-2">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.roof_by_others)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>by Others</span>
              </label>
            </div>
            <div className="tw-col-span-10">
              <div className="tw-flex tw-gap-3 tw-items-center">
                <div>Color:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds1.roof_color}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-border tw-py-2">
            <div className="tw-col-span-2">Insulation</div>
            <div className="tw-col-span-10">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-3">
                <div className="tw-col-span-8">
                  <div>
                    <label className="tw-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds1.roof_insulation_by_pebsteel)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>by PEB Steel</span>
                    </label>
                  </div>
                  <div className="tw-flex tw-gap-2">
                    <div className="tw-flex-1">
                      <span className="tw-text-primary-600">{bds1.roof_name}</span>
                    </div>
                    <div className="tw-flex-1">
                      <div className="tw-flex tw-gap-2 tw-items-center">
                        <div>Thickness (mm):</div>
                        <div className="tw-flex-1">
                          <span className="tw-text-primary-600">{bds1.roof_insulation_thickness}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tw-col-span-4">
                  <div>
                    <label className="tw-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds1.roof_insulation_by_others)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>by Others</span>
                    </label>
                  </div>
                  <div className="tw-flex tw-gap-2 tw-items-center">
                    <div>Density:</div>
                    <div className="tw-flex-1">
                      <span className="tw-text-primary-600">{bds1.roof_insulation_density}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <span dangerouslySetInnerHTML={{ __html: bds1.roof_insulation_note }}></span>
                </div>
              </div>

            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-border tw-py-2">
            <div className="tw-col-span-2">Skylight</div>
            <div className="tw-col-span-10">
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(bds1.roof_skylight_by_pebsteel)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>By Pebsteel</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(bds1.roof_skylight_single_layer)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Single layer</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(bds1.roof_skylight_double_layer)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Double layers</span>
                  </label>
                </div>
                <div className="tw-w-1/3">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(bds1.roof_skylight_by_others)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>By Others</span>
                  </label>
                </div>
              </div>
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <div>Width (mm):</div>
                  <span className="tw-text-primary-600">{bds1.roof_skylight_width}</span>
                </div>
                <div className="tw-flex-1">
                  <div>Length (mm):</div>
                  <span className="tw-text-primary-600">{bds1.roof_skylight_length}</span>
                </div>
                <div className="tw-flex-1">
                  <div>Thickness (mm):</div>
                  <span className="tw-text-primary-600">{bds1.roof_skylight_thickness}</span>
                </div>
                <div className="tw-flex-1">
                  <div>Color:</div>
                  <span className="tw-text-primary-600">{bds1.roof_skylight_color}</span>
                </div>
                <div className="tw-w-1/3">
                  <div>Description:</div>
                  <span className="tw-text-primary-600">{bds1.roof_skylight_desciption}</span>
                </div>
              </div>
              <div className="tw-flex tw-gap-2 tw-mt-3">
                <div className="tw-flex-1">
                  <span dangerouslySetInnerHTML={{ __html: bds1.roof_skylight_note }}></span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">8</td>
        <td className="tw-font-bold tw-text-center">WALL</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-2">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.wall_by_pebsteel)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>by PEB Steel</span>
              </label>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Panel is:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds1.wall_panel_is}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-5">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Profile:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds1.wall_profile}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-2">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.wall_by_others)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>by Others</span>
              </label>
            </div>
            <div className="tw-col-span-10">
              <div className="tw-flex tw-gap-3 tw-items-center">
                <div>Color:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{bds1.wall_color}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-border tw-py-2">
            <div className="tw-col-span-2">Insulation</div>
            <div className="tw-col-span-10">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-3">
                <div className="tw-col-span-8">
                  <div>
                    <span className="tw-text-primary-600">{bds1.wall_insulation_by_pebsteel}</span>
                  </div>
                  <div className="tw-flex tw-gap-2">
                    <div className="tw-flex-1">
                      <span className="tw-text-primary-600">{bds1.wall_name}</span>
                    </div>
                    <div className="tw-flex-1">
                      <div className="tw-flex tw-gap-2 tw-items-center">
                        <div>Thickness (mm):</div>
                        <div className="tw-flex-1">
                          <span className="tw-text-primary-600">{bds1.wall_insulation_thickness}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tw-col-span-4">
                  <div>
                    <label className="tw-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(bds1.wall_insulation_by_others)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>by Others</span>
                    </label>
                  </div>
                  <div className="tw-flex tw-gap-2 tw-items-center">
                    <div>Density:</div>
                    <div className="tw-flex-1">
                      <span className="tw-text-primary-600">{bds1.wall_insulation_density}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <span dangerouslySetInnerHTML={{ __html: bds1.wall_insulation_note }}></span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-border tw-py-2">
            <div className="tw-col-span-2">Wall light</div>
            <div className="tw-col-span-10">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2">
                <div className="tw-col-span-8">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(bds1.wall_light_by_pebsteel)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>By Pebsteel</span>
                  </label>
                </div>
                <div className="tw-col-span-4">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(bds1.wall_light_by_others)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>By Others</span>
                  </label>
                </div>
              </div>
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <div>Width (mm):</div>
                  <span className="tw-text-primary-600">{bds1.wall_light_width}</span>
                </div>
                <div className="tw-flex-1">
                  <div>Length (mm):</div>
                  <span className="tw-text-primary-600">{bds1.wall_light_length}</span>
                </div>
                <div className="tw-flex-1">
                  <div>Thickness (mm):</div>
                  <span className="tw-text-primary-600">{bds1.wall_light_thickness}</span>
                </div>
                <div className="tw-flex-1">
                  <div>Color:</div>
                  <span className="tw-text-primary-600">{bds1.wall_light_color}</span>
                </div>
                <div className="tw-w-1/3">
                  <div>Description:</div>
                  <span className="tw-text-primary-600">{bds1.wall_light_description}</span>
                </div>
              </div>
              <div className="tw-flex tw-gap-2 tw-mt-3">
                <div className="tw-flex-1">
                  <span dangerouslySetInnerHTML={{ __html: bds1.wall_light_note }}></span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">9</td>
        <td className="tw-font-bold tw-text-center">Sheeting Angle, <br/> Gable Angle, Eave Angle <br/>(If sheeting by
others)</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-8">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.sheeting_angle_by_pebsteel)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>By Pebsteel</span>
              </label>
            </div>
            <div className="tw-col-span-4">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.sheeting_angle_by_others)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>By Others</span>
              </label>
            </div>
          </div>
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <span dangerouslySetInnerHTML={{ __html: bds1.sheeting_angle_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">10</td>
        <td className="tw-font-bold tw-text-center">EAVE CONDITION</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.eave_condition_gutter_downspouts)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Gutters & Downspouts,</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.eave_condition_trim)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Eave Trim,</span>
              </label>
            </div>
            <div className="tw-flex-1"></div>
            <div className="tw-flex-1"></div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-2">
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.eave_condition_curved_projection)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Curved Eave with projection,</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.eave_condition_w_o_gutters_downspouts)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>w/o Gutters & Downspouts,</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.eave_condition_w_valley_gutters_downspouts)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>w/Valley Gutters & Downspouts,</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-justify-between">
                <div>Downspouts</div>
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds1.eave_condition_downspouts_meta)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Metal</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds1.eave_condition_downspouts_pvc)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>PVC</span>
                </label>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.eave_condition_curved_projection2)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Curved Eave w/o projection,</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.eave_condition_w_o_gutters_downspouts2)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>w/o Gutters & Downspouts,</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(bds1.eave_condition_w_valley_gutters_downspouts2)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>w/Valley Gutters & Downspouts,</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-justify-between">
                <div>Downspouts</div>
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds1.eave_condition_downspouts_meta2)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Metal</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(bds1.eave_condition_downspouts_pvc2)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>PVC</span>
                </label>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mt-2">
            <div className="tw-flex-1">
              <span dangerouslySetInnerHTML={{ __html: bds1.eave_condition_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">11</td>
        <td className="tw-font-bold tw-text-center">WALL TRIM COLORS</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-3">
            <div className="tw-col-span-4">
              <div>Color of gutters, down spouts, Eave trim :</div>
              <span className="tw-text-primary-600">{bds1.wall_trim_colors}</span>
            </div>
            <div className="tw-col-span-8">
              <span dangerouslySetInnerHTML={{ __html: bds1.wall_trim_colors_gutters_note }}></span>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2">
            <div className="tw-col-span-4">
              <div>Color of other flashing, trim:</div>
              <span className="tw-text-primary-600">{bds1.wall_trim_colors_others}</span>
            </div>
            <div className="tw-col-span-8">
              <span dangerouslySetInnerHTML={{ __html: bds1.wall_trim_colors_flashing_note }}></span>
            </div>
          </div>
        </td>
      </tr>
    </table>
  )
};

BDS1.propTypes = {
  pif: PropTypes.object.isRequired,
  area: PropTypes.array.isRequired
}

export default BDS1;
